<template>
  <q-page>
    <div>
      <account-menu
        v-if="isUserLoggedIn()"
        :menu-items="menuItems"
        @change="handleClick"
      />
      <change-language v-model="dialog" />
      <div
        v-if="!isUserLoggedIn()"
        class="row justify-center q-mt-md q-gutter-y-md q-pa-md"
      >
        <q-btn
          v-for="(btn, index) in authButtons"
          :key="index"
          class="full-width custom-btn text-weight-regular q-px-none"
          @click="btn.method"
          no-caps
          unelevated
          rounded
          :class="btn.style"
        >
          <template #default>
            <div
              class="row items-center justify-center no-wrap full-width q-pl-sm"
            >
              <span>{{ btn.label }}</span>
            </div>
          </template>
        </q-btn>

        <div id="google-login-button" class="text-center"></div>

        <div class="full-width">
          <divider :text="textDivider" margin="q-my-none" />
        </div>
        <q-btn
          v-for="(btn, index) in forgotPasswordButtons"
          :key="index"
          class="full-width custom-btn text-weight-regular q-px-none"
          @click="btn.method"
          no-caps
          unelevated
          rounded
          :class="btn.style"
        >
          <template #default>
            <div class="row items-center justify-center no-wrap full-width">
              <span>{{ btn.label }}</span>
            </div>
          </template>
        </q-btn>
      </div>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useLang } from "@/composables/useLang";
import { useBase } from "@/composables/useBase";
import AccountMenu from "@/components/menu/Account.vue";
import ChangeLanguage from "@/components/popup/ChangeLanguage.vue";
import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";
import { useSEOMeta } from "@/composables/useSEOMeta";
import { useAuth } from "@/composables/useAuth";
import { useGoogleAccount } from "@/composables/useGoogleAccount";
import Divider from "@/components/Divider.vue";
import {
  mdiInvoiceListOutline,
  mdiAccountCircle,
  mdiMapMarker,
  mdiInformationOutline,
  mdiExitToApp
} from "@quasar/extras/mdi-v7";
const { isUserLoggedIn } = useAuth();
useGoogleAccount();

const { router } = useBase();

const textDivider = computed(() => t("or"));
const dialog = ref(false);
const { t } = useLang();
const { signOut } = useAuth();

const menuItems = computed(() => [
  {
    icon: mdiInvoiceListOutline,
    label: t("page.account.list_order"),
    col: "6",
    route: ACCOUNT_ROUTE_NAME.ORDER_LIST
  },
  {
    icon: mdiAccountCircle,
    label: t("page.account.account"),
    col: "6",
    route: ACCOUNT_ROUTE_NAME.ACCOUNT_PROFILE
  },
  {
    icon: mdiMapMarker,
    label: t("page.account.address_payment"),
    col: "6",
    route: ACCOUNT_ROUTE_NAME.ADDRESS_PAYMENT
  },
  {
    icon: mdiInformationOutline,
    label: t("page.account.about_us"),
    col: "6",
    route: ACCOUNT_ROUTE_NAME.ABOUT_US
  },
  {
    icon: mdiExitToApp,
    label: t("page.auth.signout"),
    col: "6",
    route: "signout"
  }
]);

const authButtons = computed(() => [
  {
    label: t("page.auth.sign_in_email"),
    style: "bg-primary text-white wee-text-weight-bold",
    method: () => redirectTo("signin")
  }
  // {
  //   label: t("page.auth.sign_in_google"),
  //   style: "border-color-primary text-grey-8 wee-text-weight-bold",
  //   img: google,
  //   method: signInGoogle
  // }
]);

const forgotPasswordButtons = ref([
  {
    label: t("signup"),
    style: "bg-secondary text-white wee-text-weight-bold",
    method: () => redirectTo("signup")
  },
  {
    label: t("forgot_password"),
    style: " bg-positive text-white wee-text-weight-bold",
    method: () => redirectTo("forgot-password")
  }
]);

const redirectTo = (value: string) => {
  router.push({ name: value });
};

const handleClick = (item: string) => {
  if (item === "language") {
    dialog.value = true;
  } else if (item === "signout") {
    signOut();
  } else {
    router.push({ name: item });
  }
};

useSEOMeta({
  title: "My Account",
  description:
    "Manage your Nailsupply account settings, view order history, update profile information, and access affiliate programs.",
  keywords:
    "Nailsupply account, Profile settings, Order history, Account management",
  url: "/account",
  noIndex: true,
  twitterHandle: "@nailsupply"
});
</script>

<style scoped>
.orders-list {
  max-width: 800px;
  margin: 0 auto;
}
</style>
